import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';

import { IIdentityPool } from '../serverApi/types/identityPools/IIdentityPool';


export namespace IdentityPoolService {

    export function kickoffLogin(identityPool: IIdentityPool): void {
        WindowLocationService.navigateToWithoutAddingToHistory('/authn-service/authenticate/' + identityPool.id);
    }

}

export type IdentityPoolService = typeof IdentityPoolService;
